(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/button-description.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/button-description.js');
"use strict";


const ButtonWithDescription = _ref => {
  let {
    button,
    description
  } = _ref;
  const {
    content = null,
    classNames = 'payfooter-block center-text margin-1'
  } = description;
  return React.createElement(React.Fragment, null, button, content && React.createElement("div", {
    className: classNames
  }, content));
};
svs.tur.ReactPayfooter.ButtonWithDescription = ButtonWithDescription;

 })(window);